import { createContext } from 'react';

const UNSAFE_ButtonContext = /*#__PURE__*/createContext({});

export { UNSAFE_ButtonContext };
